import { Navigate } from "react-router-dom";

import { PAY_QR_PARAM } from "@/modules/dashboard/wallets/constants/wallets.constants";

/** Paying a QR is a send from the COP wallet: this entry opens that panel on the camera. */
export const BrebQrPayNavigation = () => <Navigate to={`/app/wallets?${PAY_QR_PARAM}=1`} replace />;
